import React from 'react';

const Navbar = ({ activePage, isSidebarCollapsed }) => {
  const pageTitles = {
    dashboard: 'Dashboard',
    business: 'Business Collection',
    client: 'Client Management',
    system: 'System Management',
    license: 'License Management',
    payment: 'Payment Management',
    logs: 'Business Logs',
  };

  const currentTitle = pageTitles[activePage] || 'Admin Panel';

  return (
    <header 
      className="fixed top-0 z-40 bg-white border-b border-gray-100 transition-all duration-300"
      style={{ 
        left: isSidebarCollapsed ? '5rem' : '16rem',
        right: 0 
      }}
    >
      <div className="px-7 py-4">
        {/* Modern Minimal Design */}
        <div className="flex items-center space-x-3">
          {/* Accent Bar */}
          <div className="w-1 h-5 bg-blue-500 rounded-full"></div>
          
          {/* Breadcrumb Text */}
          <div className="flex items-center space-x-2">
            <span className="text-base text-gray-600">
              License Management
            </span>
            <span className="text-base text-gray-300">→</span>
            <span className="text-base font-semibold text-gray-800">
              {currentTitle}
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;